import { render, staticRenderFns } from "./GarageTab.vue?vue&type=template&id=601d9878&scoped=true"
import script from "./GarageTab.vue?vue&type=script&lang=js"
export * from "./GarageTab.vue?vue&type=script&lang=js"
import style0 from "./GarageTab.vue?vue&type=style&index=0&id=601d9878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d9878",
  null
  
)

export default component.exports